import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import meetingApi from '@/services/meeting';
import * as organMgr from '@/services/organMgr';
export default {
  name: 'MeetingDetail',
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data: function data() {
    return {
      detail: {},
      loading: false,
      // 审批相关
      approvalVisible: false,
      submitting: false,
      currentRecord: null,
      approvalForm: {
        deptName: '',
        result: '1',
        comment: '',
        taskId: '',
        assigneeId: '' // 办理人ID
      },
      assigneeList: [],
      // 办理人列表
      assigneeLoading: false // 办理人加载状态
    };
  },
  watch: {
    id: {
      handler: function handler(newId) {
        if (newId) {
          this.loadDetail(newId);
        }
      },
      immediate: true
    }
  },
  computed: {
    // 判断是否需要显示审批结果
    showApprovalResult: function showApprovalResult() {
      if (!this.currentRecord || !this.currentRecord.taskName) {
        return false;
      }
      var taskName = this.currentRecord.taskName;
      return taskName === '行政办负责人审批' || taskName === '小学综合办负责人审批' || taskName === '服务处室负责人审批';
    },
    // 判断是否需要显示办理人选择
    showAssigneeSelect: function showAssigneeSelect() {
      return this.currentRecord && (this.currentRecord.taskName === '服务处室负责人审批' || this.currentRecord.taskName === '会议室管理部门审批');
    }
  },
  methods: {
    loadDetail: function loadDetail(id) {
      var _this = this;
      this.loading = true;
      meetingApi.queryReservationDetail({
        id: id
      }).then(function (res) {
        if (res.data && res.data.code === 200) {
          _this.detail = res.data.data || {};
        } else {
          _this.$message.error(res.data.message || '获取详情失败');
          _this.detail = {};
        }
      }).catch(function (err) {
        _this.$message.error('获取详情失败');
        _this.detail = {};
      }).finally(function () {
        _this.loading = false;
      });
    },
    getFlowStatusText: function getFlowStatusText(status) {
      if (status === null || status === undefined || status === '') {
        return '办理中';
      }
      var statusStr = String(status);
      if (statusStr === '1') {
        return '已办理';
      }
      if (statusStr === '0') {
        return '审核不通过';
      }
      var statusMap = {
        'STARTED': '开始',
        'COMPLETED': '完成',
        'PENDING': '待处理',
        'APPROVED': '已批准',
        'REJECTED': '已拒绝',
        'CANCELLED': '已取消'
      };
      return statusMap[status] || status;
    },
    getFlowStatusColor: function getFlowStatusColor(status) {
      if (status === null || status === undefined || status === '') {
        return 'orange';
      }
      var statusStr = String(status);
      if (statusStr === '1') {
        return 'green';
      }
      if (statusStr === '0') {
        return 'red';
      }
      var colorMap = {
        'STARTED': 'blue',
        'COMPLETED': 'green',
        'PENDING': 'orange',
        'APPROVED': 'green',
        'REJECTED': 'red',
        'CANCELLED': 'gray'
      };
      return colorMap[status] || 'default';
    },
    getCommentText: function getCommentText(commentStr) {
      try {
        var commentObj = JSON.parse(commentStr);
        return commentObj.comment || '';
      } catch (e) {
        return commentStr;
      }
    },
    // 处理审批按钮点击
    handleApprove: function handleApprove(record) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var organId, response, arr, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this2.currentRecord = record;
              _this2.approvalForm.deptName = record.deptName || '';
              _this2.approvalForm.result = '1';
              _this2.approvalForm.comment = '';
              _this2.approvalForm.taskId = record.taskId || '';
              _this2.approvalForm.assigneeId = '';
              _this2.assigneeList = [];

              // 当任务是服务处室负责人审批时，获取办理人列表
              if (!((record.taskName === '服务处室负责人审批' || record.taskName === '会议室管理部门审批') && record.deptId)) {
                _context.n = 5;
                break;
              }
              _context.p = 1;
              _this2.assigneeLoading = true;
              // 从 deptId 中提取 organId（按 : 分割，取第一元素）
              organId = record.deptId.split(':')[0];
              _context.n = 2;
              return organMgr.initGwTable({
                organId: organId,
                type: 3,
                pageCurrent: 1,
                pageSize: 999
              });
            case 2:
              response = _context.v;
              if (response.data && response.data.code === 200) {
                arr = [];
                response.data.record.forEach(function (item) {
                  if (!arr.includes(item.postId)) {
                    arr.push(item.postId);
                    _this2.assigneeList.push({
                      userId: item.organId + ":" + item.postId,
                      userName: item.postName
                    });
                  }
                });
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              _context.p = 4;
              _this2.assigneeLoading = false;
              return _context.f(4);
            case 5:
              _this2.approvalVisible = true;
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }))();
    },
    // 取消审批
    cancelApproval: function cancelApproval() {
      this.approvalVisible = false;
      this.currentRecord = null;
      this.approvalForm = {
        deptName: '',
        result: '1',
        comment: '',
        taskId: '',
        assigneeId: ''
      };
      this.assigneeList = [];
      this.assigneeLoading = false;
    },
    // 提交审批
    submitApproval: function submitApproval() {
      var _this3 = this;
      // 当不需要显示审批结果时，默认设置为通过
      if (!this.showApprovalResult) {
        this.approvalForm.result = '1';
      } else if (!this.approvalForm.result) {
        this.$message.warning('请选择审批结果');
        return;
      }

      // 当需要选择办理人时，检查是否选择了办理人
      if (this.showAssigneeSelect && !this.approvalForm.assigneeId) {
        this.$message.warning('请选择办理人');
        return;
      }
      this.submitting = true;
      // 调用审批接口
      var params = {
        taskName: this.currentRecord.taskName,
        reservationId: this.id,
        approvalAction: this.approvalForm.result === '1' ? 'PASS' : 'REJECT',
        approvalComment: this.approvalForm.comment
      };
      if (this.approvalForm.taskId) {
        params.taskId = this.approvalForm.taskId;
      }
      if (this.approvalForm.assigneeId) {
        params.assigneeId = this.approvalForm.assigneeId;
      }
      meetingApi.approve(params).then(function (res) {
        if (res.data && res.data.code === 200) {
          _this3.$message.success('审批成功');
          _this3.loadDetail(_this3.id);
          _this3.cancelApproval();
          _this3.$emit('approval-success');
        } else {
          _this3.$message.error(res.data.message || '审批失败');
        }
      }).catch(function (err) {
        _this3.$message.error('审批失败');
      }).finally(function () {
        _this3.submitting = false;
      });
    }
  }
};